import { constant } from "../constant";

const initialState = {
  uniqueId: null,
};

const ConfirmBookingDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case constant.SET_CONFIRM_BOOKING_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case constant.CLEAN_CONFIRM_BOOKING_DATA:
      return initialState;
    case constant.SELECT_DATE_TIME_OPEN:
      return {
        ...state,
        uniqueId: action.uniqueId,
      };
    case constant.SET_INSTRUCTOR_STUDIO_LOCATION:
      return {
        ...state,
        instructorStudioLocations: action.payload,
      };
    default:
      return state;
  }
};

export default ConfirmBookingDataReducer;
